<script>
export default {
  name: 'TableCell',
  props: {
    align: {
      type: String,
      default: 'left',
      validate: (value) => ['left', 'center', 'right'].includes(value),
    },
    wrap: {
      type: Boolean,
      default: false,
    },
    blocked: {
      type: Boolean,
      default: false,
    },
    lockable: {
      type: Boolean,
      default: true,
    },
    isAction: {
      type: Boolean,
      default: false,
    },
    unpinAction: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    classes() {
      return {
        [`-${this.align}`]: true,
        '-wrap': this.wrap,
        '-action': this.isAction,
        '-visible': this.unpinAction,
      };
    },
  },
};
</script>

<template>
  <td
    class="cxm-TableCell"
    :class="classes"
  >
    <span
      v-if="blocked === true && lockable === true"
      class="cxm-TableCell-Blur"
    >
      locked
    </span>
    <div
      v-else-if="isAction"
      class="cxm-TableCell-ActionCell"
    >
      <slot />
    </div>
    <slot v-else />
  </td>
</template>

<style lang="scss" scoped>
.cxm-TableCell {
  border: 0 solid var(--track-color-bluegray-20);
  border-top-width: var(--track-border-sm);
  color: var(--track-color-bluegray-80);
  font-size: var(--track-font-size-xxs);
  font-weight: var(--track-font-weight-medium);
  height: 42px;
  line-height: var(--track-line-height-far);
  overflow: hidden;
  padding: var(--track-spacing-sm);
  padding-right: var(--track-spacing-md);
  text-align: left;
  text-overflow: ellipsis;
  vertical-align: middle;
  white-space: nowrap;

  &.-wrap {
    white-space: normal;
  }

  &.-action:not(.-visible) {
    padding: 0;
    position: sticky;
    right: 0;
    transition: background-color 0.2s ease;
    width: 0;

    tr:hover & {
      background-color: var(--track-color-bluegray-10);
    }
  }

  &.-left {
    text-align: left;
  }
  &.-center {
    text-align: center;
  }
  &.-right {
    text-align: right;
  }

  &:first-child {
    border-left-width: var(--track-border-sm);
  }
  &:last-child {
    border-right-width: var(--track-border-sm);
  }

  .cxm-TableContent & {
    &:first-child,
    &:last-child {
      border-left-width: 0;
      border-right-width: 0;
    }
  }

  tr:first-child & {
    border-top: 0;
  }
}

.cxm-TableCell-ActionCell {
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: flex-end;
  opacity: 0;
  padding: 0 var(--track-spacing-sm);
  transition: opacity 0.2s ease;

  tr:hover & {
    opacity: 1;
  }

  .cxm-TableCell.-action.-visible & {
    justify-content: center;
    opacity: 1;
    padding: 0;
  }
}

.cxm-TableCell-Blur {
  filter: blur(5px);
  user-select: none;
}
</style>
